'use strict';
const angular = require('angular');

/*@ngInject*/
export function ImportantNumberService($resource) {
  return $resource('/api/important-numbers/:id', {
    id: '@_id'
  },{
    patch: {
      method: 'PATCH'
    },
    upsert: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.ImportantNumberService', [])
  .factory('ImportantNumberService', ImportantNumberService)
  .name;



// WEBPACK FOOTER //
// ./client/services/important-numbers/important-number.service.js